export default __webpack_public_path__ + "static/media/Frame.5641d774.svg";